import { render } from "./loading_modal.vue?vue&type=template&id=af191da2&scoped=true"
const script = {}

import "./loading_modal.vue?vue&type=style&index=0&id=af191da2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af191da2"]])

export default __exports__